<template>
  <!--
    Identity column: brand-ring avatar + name + View Profile, fixed-width and
    centered, matching the Figma 135px identity column.
  -->
  <div
    class="flex shrink-0 flex-col items-center justify-center gap-3 text-center lg:w-[135px]"
  >
    <RouterLink
      :to="{
        name: RouteNames.Profile,
        params: { channel: channelSlug },
      }"
      class="rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-brand"
      data-testid="channel-profile-card-avatar-link"
    >
      <!-- Brand ring: outer brand-fill rounded wrapper + thin inner
           bg gap (matches page background), exactly as the Figma identity
           avatar treatment (brand-red ring around the avatar). -->
      <span class="block rounded-full bg-fill-brand p-[2px]">
        <span class="block rounded-full border-[3px] border-surface-secondary">
          <Avatar
            :avatar="{
              name: username,
              image: avatar,
              id: userId,
            }"
            size="2md"
          />
        </span>
      </span>
    </RouterLink>

    <div class="flex flex-col items-center gap-0.5">
      <div class="flex flex-row flex-wrap items-center justify-center gap-1.5">
        <p
          class="min-w-0 truncate text-[15px] font-semibold uppercase text-text"
          data-testid="channel-profile-card-username"
        >
          {{ username }}
        </p>

        <span class="inline-flex shrink-0 flex-row items-center gap-1.5">
          <CountryBadge :icon="countryIso" class="inline" />
          <PremiumBadge v-if="isSuperfan" size="sm" class="inline" />
        </span>
      </div>

      <RouterLink
        :to="{
          name: RouteNames.Profile,
          params: { channel: channelSlug },
        }"
        custom
      >
        <template #default="{ navigate }">
          <button
            type="button"
            class="rounded-sm text-[13px] font-medium leading-[20px] text-text-secondary transition-colors hover:text-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-brand"
            data-testid="channel-profile-card-view-profile"
            @click="navigate"
          >
            {{ t("channel.profileCard.viewProfile") }}
          </button>
        </template>
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterLink } from "vue-router";
import { useI18n } from "vue-i18n";
import { RouteNames } from "@/router/app.router";
import Avatar from "@/components/me/avatar.vue";
import PremiumBadge from "@/components/badge/premium-badge.vue";
import CountryBadge from "@/components/badge/country-badge.vue";

defineProps<{
  username: string;
  avatar?: string | null;
  userId: string;
  countryIso?: string | null;
  isSuperfan: boolean;
  channelSlug: string | null;
}>();

const { t } = useI18n();
</script>
